import type { AfterShipAdsEnvironment } from '@fff-web/aftership-ads';

const appEnv = process.env.REACT_APP_ENVIRONMENT as 'dev' | 'prod';
const hostname = process.env.REACT_APP_HOSTNAME;
const aceApi = process.env.REACT_APP_ACE_API;
const userEndpoint = process.env.REACT_APP_USER_API;
const myAccountApi = process.env.REACT_APP_MY_ACCOUNT_API;
const avatarApi = process.env.REACT_APP_AVATAR_API;
const accountApi = process.env.REACT_APP_ACCOUNT_API;
const baseSiteUrl = process.env.REACT_APP_SITE_URL;
const configuredAftershipAdsEnvironment = process.env.REACT_APP_AFTERSHIP_ADS_ENVIRONMENT;
const aftershipAdsEnvironment: AfterShipAdsEnvironment | undefined =
  configuredAftershipAdsEnvironment === 'staging' ||
  configuredAftershipAdsEnvironment === 'production'
    ? configuredAftershipAdsEnvironment
    : undefined;
// Fail closed on a missing or invalid environment rather than using the vendor default.
const aftershipAdsAppKey = aftershipAdsEnvironment
  ? process.env.REACT_APP_AFTERSHIP_ADS_APP_KEY
  : undefined;

export {
  appEnv,
  hostname,
  aceApi,
  userEndpoint,
  myAccountApi,
  avatarApi,
  accountApi,
  baseSiteUrl,
  aftershipAdsAppKey,
  aftershipAdsEnvironment,
};
